<template>
  <div class="navbar">
    <nav class="red lighten-2 nav-extended">
      <div class="nav-wrapper">
        <router-link :to="{ name: 'Home' }">
          <span class="brand-logo left">Tracker</span>
        </router-link>
        <a href="#" class="right hide-on-med-and-up" @click="showNav"><i class="material-icons">menu</i></a>
        <ul class="right right hide-on-med-and-down">
          <li><router-link :to="{ name: 'Reading' }">Reading</router-link></li>
          <li><router-link :to="{ name: 'Gaming' }">Gaming</router-link></li>
          <li><router-link :to="{ name: 'Watching' }">Watching</router-link></li>
        </ul>
      </div>
      <div v-if="mobile" class="nav-content">
        <ul class="tabs tabs-transparent">
          <li class="tab"><router-link :to="{ name: 'Reading' }">Reading</router-link></li>
          <li class="tab"><router-link :to="{ name: 'Gaming' }">Gaming</router-link></li>
          <li class="tab"><router-link :to="{ name: 'Watching' }">Watching</router-link></li>
        </ul>
      </div>
    </nav>
  </div>
</template>

<script>
export default {
  name: 'Navbar',
  data() {
    return {
      mobile: false
    }
  },
  methods: {
    showNav() {
      this.mobile = !this.mobile
    }
  }
}
</script>

<style scoped>
.navbar nav {
  padding: 0 20px;
}
</style>
